import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { useSelectMapPosition } from 'hooks/map/useSelectMapPosition';
import { ICoordinates } from 'react-give-me-map';
import { MapRef } from 'react-map-gl';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    onCoordinateSelected?: (coordinate: ICoordinates) => void;
    mapRef: MapRef;
}

export const SelectPositionButton = (props: Props): JSX.Element => {
    const { isSelectActive, setIsSelectActive } = useSelectMapPosition({
        mapRef: props.mapRef,
        onCoordinateSelected: (coordinate) => {
            props.onCoordinateSelected?.(coordinate);
        }
    });

    return (
        <S_SelectPositionButton className={props.className}>
            {!isSelectActive && (
                <ActionButton
                    highlighted={isSelectActive}
                    icon={{ iconName: 'thumbtack' }}
                    text={Localization.POSITION}
                    onClick={() => {
                        setIsSelectActive(!isSelectActive);
                    }}
                />
            )}
            {isSelectActive && <S_Message type="info">{Localization.POSITION_DESC}</S_Message>}
        </S_SelectPositionButton>
    );
};

const S_SelectPositionButton = styled.div``;

const S_Message = styled(Message)`
    margin: 0;
`;
